import { Route, Routes } from "react-router-dom";
import { SignAsUser } from "../pages/SignAsUser";
import { SignIn } from "../pages/SignIn";
import { SignoutAsUser } from "../pages/SignoutAsUser";
import { RecoverPassword } from "../pages/RecoverPassword";
import { ResetPassword } from "../pages/ResetPassword";

export function AuthRoutes() {
  return (
    <Routes>
      <Route path="/" element={<SignIn />} />
      <Route path="sign-as-user/:token" element={<SignAsUser />} />
      <Route path="/recover" element={<RecoverPassword />} />
      <Route path="/reset/:token" element={<ResetPassword />} />
      <Route path="*" element={<SignoutAsUser />} />
    </Routes>
  );
}
